<template>
  <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
    <!-- <van-nav-bar
        title="收藏职位"
        left-arrow
        fixed
        placeholder
        @click-left="onClickLeft">
      </van-nav-bar> -->
    <ul class="job-list">
      <li
        v-for="item in jobsList"
        :key="item.index"
        @click="jobDetail(item.id)"
      >
        <div class="detail-info">
          <div class="info-header">
            <h3>
              {{ item.jobName }} <small v-if="item.urgent == 1">急</small>
            </h3>
            <span>{{ item.salary }}</span>
          </div>
          <ul class="conditionList">
            <li>
              {{ item.expLevel }}
            </li>
            <li>
              {{ item.eduLevel }}
            </li>
          </ul>
          <ul class="feature">
            <li>
              {{ item.enterpriseName }}
            </li>
            <li>
              {{ item.personnelSize }}
            </li>
            <!-- <li>
                {{item.}}
              </li> -->
          </ul>
          <div class="contact">
            <div class="person">
              <img v-if="item.recruitersAvatar" :src="item.recruitersAvatar" />
              <img v-else src="../../../../assets/img/avatar.png" />
              <span
                >{{ item.recruitersName }}·{{ item.recruitersJobTitle }}</span
              >
            </div>
            <div class="place">
              {{ item.jobArea }}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </van-list>
</template>

<script>
export default {
  name: "collectionJobs",
  data() {
    return {
      jobsList: [],
      current: 1,
      loading: false,
      finished: false
    };
  },
  methods: {
    onLoad() {
      this.module.api.posCollectList({
        params: {
          current: this.current,
          size: 10
        },
        success: res => {
          this.jobsList = this.jobsList.concat(res.records);
          res.pages > this.current && this.current++;
          this.loading = false;
          if (this.jobsList.length >= res.total) {
            this.finished = true;
          }
        }
      });
    },
    jobDetail(id) {
      this.$router.push({ name: "jobDetail", query: { id } });
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.job-list {
  margin-left: 0;
  margin-right: 0;
  margin-top: 10px;
  & > li {
    padding: 6px 16px;
    border-bottom: 8px solid #f7f7f7;
    &:last-child {
      border-bottom: 0;
    }
  }
}
</style>
